import { NgModule } from '@angular/core';
import { ButtonV2Module, ModalModule } from '@schenck/rotec-components';
import { LanguageModalComponent } from './language-modal/language-modal.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [ModalModule.forRoot(), TranslateModule, ButtonV2Module, LanguageModalComponent],
  exports: [LanguageModalComponent],
})
export class ModalsModule {}
